export default __webpack_public_path__ + "static/media/school.12dc4ada.svg";